// Mirrors the CourseKind C# enum DatabaseValue mappings (All has no DatabaseValue attribute)
export const CourseKind = Object.freeze({
    Program: 'program',
    Module: 'module',
    RolePlayAi: 'roleplay_ai',
    Webinar: 'webinar',
    Article: 'article',
    ShareableContentObject: 'shareablecontentobject',
    LearningPath: 'learningpath',
    Video: 'video',
    Course: 'course',
    XApiObject: 'xapiobject',
    CourseGroup: 'coursegroup',
    MicroCourse: 'microcourse',
    WebinarCourse: 'webinarcourse',
    Capability: 'capability',
});

export default CourseKind;
